import React, { useState, useEffect, useRef, useContext } from "react";

import { useHistory, useParams } from "react-router-dom";
import { parseISO, format, isSameDay } from "date-fns";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import Badge from "@material-ui/core/Badge";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import MarkdownWrapper from "../MarkdownWrapper";
import { Tooltip, IconButton } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { PinCheio, PinVazado } from "../IconePin";
import { formatarNomeOuTelefone } from "../../utils/phone";
import { FavoritosContext } from "../../context/Favoritos/FavoritosContext";
import TransferTicketModal from "../TransferTicketModal";
import ConfirmationModal from "../ConfirmationModal";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MicIcon from "@material-ui/icons/Mic";
import PersonIcon from "@material-ui/icons/Person";
import SignalWifiOffIcon from "@material-ui/icons/SignalWifiOff";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

const useStyles = makeStyles(theme => ({
	ticket: {
		position: "relative",
		margin: "6px 10px",
		borderRadius: "14px",
		border: theme.palette.type === "dark" ? "1px solid rgba(74, 222, 128, 0.08)" : "1px solid #e6efe9",
		backgroundColor: theme.palette.type === "dark" ? "#1a221f !important" : "#ffffff !important",
		boxShadow: theme.palette.type === "dark" ? "none" : "0 1px 3px rgba(16, 40, 28, 0.04)",
		transition: "transform .2s ease, box-shadow .2s ease, border-color .2s ease, background-color .2s ease",
		animation: "iaSubir .3s ease backwards",
		// atendimento aberto: fundo verde bem leve + borda verde
		"&.Mui-selected": {
			backgroundColor: theme.palette.type === "dark" ? "rgba(34, 197, 94, 0.12) !important" : "#eefaf2 !important",
			borderColor: theme.palette.type === "dark" ? "rgba(74, 222, 128, 0.45)" : "#9fdcb6",
			boxShadow: theme.palette.type === "dark"
				? "0 0 0 1px rgba(74, 222, 128, 0.15), 0 6px 18px rgba(0, 0, 0, 0.35)"
				: "0 6px 16px rgba(30, 152, 85, 0.12)",
		},
		"&:hover": {
			transform: "translateY(-2px)",
			borderColor: theme.palette.type === "dark" ? "rgba(74, 222, 128, 0.3)" : "#bfe3cc",
			boxShadow: theme.palette.type === "dark"
				? "0 8px 20px rgba(0, 0, 0, 0.4)"
				: "0 8px 20px rgba(16, 40, 28, 0.08)",
		},
		"&:hover:not(.Mui-selected)": {
			backgroundColor: theme.palette.type === "dark" ? "#212a26 !important" : "#ffffff !important",
		},
		"&:hover $acoesRapidas": { opacity: 1 },
	},

	acoesRapidas: {
		position: "absolute",
		top: 2,
		right: 6,
		display: "flex",
		gap: 2,
		opacity: 0,
		transition: "opacity 0.15s ease",
		zIndex: 2,





		backgroundColor: theme.palette.type === "dark" ? "#2a2a2a" : "#ffffff",
		borderRadius: 14,
		padding: "1px 3px",
		boxShadow: "0 1px 5px rgba(0,0,0,0.22)",
	},

	botaoAcaoRapida: {
		padding: 3,
	},

	pendingTicket: {
		cursor: "unset",
	},

	noTicketsDiv: {
		display: "flex",
		height: "100px",
		margin: 40,
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},

	noTicketsText: {
		textAlign: "center",
		color: "rgb(104, 121, 146)",
		fontSize: "14px",
		lineHeight: "1.4",
	},

	noTicketsTitle: {
		textAlign: "center",
		fontSize: "16px",
		fontWeight: "600",
		margin: "0px",
	},

	contactNameWrapper: {
		display: "flex",
		justifyContent: "space-between",
	},

	lastMessageTime: {
		justifySelf: "flex-end",

		flexShrink: 0,
		marginLeft: "auto",
		fontSize: "0.72rem",
		whiteSpace: "nowrap",
	},

	
	pilulaResolvido: {
		alignSelf: "center",
		marginLeft: "auto",
		marginRight: 6,
		backgroundColor: theme.palette.type === "dark"
			? "rgba(52,211,153,0.20)"
			: "rgba(30,152,85,0.12)",
		color: theme.palette.type === "dark" ? "#6ee7b7" : "#1E9855",
		fontSize: "0.68rem",
		fontWeight: 600,
		lineHeight: "16px",
		padding: "0 7px",
		borderRadius: 8,
		whiteSpace: "nowrap",
		flexShrink: 0,
	},

	contactLastMessage: {
		paddingRight: 20,
	},

	newMessagesCount: {
		alignSelf: "center",
		marginRight: 8,
		marginLeft: "auto",
	},

	

	
	
	badgeStyle: {
		color: "white",
		backgroundColor: "#f59e0b",
		fontWeight: 700,
	},


	ticketQueueColor: {
		flex: "none",
		width: "6px",
		height: "100%",
		position: "absolute",
		top: "0%",
		left: "0%",
		borderTopLeftRadius: "12px",
		borderBottomLeftRadius: "12px",
	},

	

	
	
	// Atendimento orfao: a conexao dele foi excluida, caiu ou foi banida. Vermelho
	// forte de proposito -- ninguem consegue responder esse cliente ate um
	// administrador escolher outra conexao.
	seloSemConexao: {
		display: "inline-flex",
		alignItems: "center",
		gap: 3,
		backgroundColor: "#dc2626",
		color: "#fff",
		padding: "0 6px",
		borderRadius: 5,
		fontSize: "0.6rem",
		fontWeight: 700,
		letterSpacing: "0.02em",
		lineHeight: "15px",
		whiteSpace: "nowrap",
	},

	selohumano: {
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
		backgroundColor: theme.palette.type === "dark"
			? "rgba(96,165,250,0.20)"
			: "rgba(37,99,235,0.12)",
		color: theme.palette.type === "dark" ? "#93c5fd" : "#1d4ed8",
		padding: "2px 8px",
		borderRadius: 6,
		fontSize: "0.7rem",
		fontWeight: 700,
		lineHeight: "16px",
		whiteSpace: "nowrap",
	},

	// Quem esta atendendo o cliente. Verde, igual ao "Resolvido", para nao
	// competir com a etiqueta azul da conexao nem com as etiquetas coloridas.
	atendenteTag: {
		display: "inline-flex",
		alignItems: "center",
		gap: 4,
		maxWidth: 170,
		overflow: "hidden",
		textOverflow: "ellipsis",
		backgroundColor: theme.palette.type === "dark"
			? "rgba(52,211,153,0.18)"
			: "rgba(30,152,85,0.12)",
		color: theme.palette.type === "dark" ? "#6ee7b7" : "#1E9855",
		padding: "2px 8px",
		borderRadius: 6,
		fontSize: "0.7rem",
		fontWeight: 600,
		lineHeight: "16px",
		whiteSpace: "nowrap",
	},


	userTag: {
		background: theme.palette.type === "dark"
			? "rgba(96, 165, 250, 0.18)"
			: "rgba(37, 99, 235, 0.10)",
		color: theme.palette.type === "dark" ? "#93c5fd" : "#1d4ed8",
		padding: "2px 8px",
		borderRadius: 6,
		fontSize: "0.7rem",
		fontWeight: 600,
		lineHeight: "16px",
		whiteSpace: "nowrap",
	},

	btnAccept: {
		borderRadius: 8,
		textTransform: "none",
		fontWeight: 600,
		fontSize: "0.8rem",
		padding: "3px 12px",
		backgroundColor: "#1E9855",
		color: "#ffffff",
		boxShadow: "none",
		"&:hover": {
			backgroundColor: "#17803f",
			boxShadow: "none",
		},
	},

	btnTransfer: {
		borderRadius: 16,
		textTransform: "none",
		fontWeight: 600,
		fontSize: "0.75rem",
		padding: "2px 14px",
		borderColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.15)" : "#e0e4e8",
		color: theme.palette.text.secondary,
		backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.02)" : "#fafafa",
		"&:hover": {
			borderColor: "#1E9855",
			color: "#1E9855",
			backgroundColor: theme.palette.type === "dark" ? "rgba(30, 152, 85, 0.08)" : "rgba(30, 152, 85, 0.04)",
		},
	},
}));

// "Áudio" e "Áudio 0:22" — e tambem o "🎤 Áudio" que ficou gravado nas
// conversas antigas, de quando o rotulo era escrito com emoji.
const RESUMO_DE_AUDIO = /^\s*(?:🎤\s*)?[ÁA]udio(\s+\d+:\d{2})?\s*$/i;

const duracaoDoResumo = (texto) => {
  const achou = String(texto || "").match(RESUMO_DE_AUDIO);
  return achou ? (achou[1] || "").trim() : "";
};

const TicketListItem = ({ ticket }) => {
	const classes = useStyles();
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
	const [menuAncora, setMenuAncora] = useState(null);
	const [confirmarApagar, setConfirmarApagar] = useState(false);
	const { ticketId } = useParams();
	const isMounted = useRef(true);
	const { user } = useContext(AuthContext);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const handleAcepptTicket = async id => {
		setLoading(true);
		try {
			await api.put(`/tickets/${id}`, {
				status: "open",
				userId: user?.id,
			});
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
		if (isMounted.current) {
			setLoading(false);
		}
		history.push(`/atendimentos/${id}`);
	};

	const handleSelectTicket = id => {
		history.push(`/atendimentos/${id}`);
	};

	const abrirMenu = e => {
		e.stopPropagation();
		setMenuAncora(e.currentTarget);
	};

	const fecharMenu = e => {
		if (e) e.stopPropagation();
		setMenuAncora(null);
	};

	// Ocultar tira da lista e nada mais: a conversa continua no banco e volta
	// pela busca. E o que o sistema faz sozinho com os finalizados de mais de
	// uma semana.
	const ocultarTicket = async e => {
		e.stopPropagation();
		fecharMenu();
		try {
			await api.put(`/tickets/${ticket.id}/ocultar`, { oculto: true });
		} catch (err) {
			toastError(err);
		}
	};

	// Apagar leva as mensagens junto e nao tem volta — por isso passa pela
	// confirmacao antes.
	const apagarTicket = async () => {
		try {
			await api.delete(`/tickets/${ticket.id}/definitivo`);
			if (String(ticketId) === String(ticket.id)) {
				history.push("/atendimentos");
			}
		} catch (err) {
			toastError(err);
		}
	};







	// Estado vem do contexto, nao de ticket.favoritoDoUsuario: aquele campo so
	// e recalculado quando a lista e buscada de novo no servidor, e por isso a
	// estrela so aparecia depois do F5.
	const {
		ehFavorito,
		ehFixado,
		alternarFavorito: alternarFavoritoCtx,
		alternarFixado: alternarFixadoCtx,
	} = useContext(FavoritosContext);

	const favorito = ehFavorito(ticket.contactId ?? ticket.contact?.id);
	const fixado = ehFixado(ticket.contactId ?? ticket.contact?.id);

	const alternarFavorito = e => {
		e.stopPropagation();
		alternarFavoritoCtx(ticket.contactId ?? ticket.contact?.id);
	};

	const alternarFixado = e => {
		e.stopPropagation();
		alternarFixadoCtx(ticket.contactId ?? ticket.contact?.id);
	};

	return (
		<React.Fragment key={ticket.id}>
			<ListItem
				dense
				button
				onClick={e => {
					handleSelectTicket(ticket.id);
				}}
				selected={ticketId && +ticketId === ticket.id}
				className={clsx(classes.ticket, {
					[classes.pendingTicket]: ticket.status === "pending",
				})}
			>
				<Tooltip
					arrow
					placement="right"
					title={ticket.tags?.[0]?.name || "Sem etiqueta"}
				>
					<span
						style={{ backgroundColor: ticket.tags?.[0]?.color || "#7C7C7C" }}
						className={classes.ticketQueueColor}
					></span>
				</Tooltip>
				{}
				<span className={classes.acoesRapidas}>
					<Tooltip title={favorito ? "Remover dos meus favoritos" : "Favoritar (só para você)"}>
						<IconButton
							size="small"
							className={classes.botaoAcaoRapida}
							onClick={alternarFavorito}
						>
							{favorito ? (
								<StarIcon fontSize="small" style={{ color: "#ffc107" }} />
							) : (
								<StarBorderIcon fontSize="small" />
							)}
						</IconButton>
					</Tooltip>

					<Tooltip title={fixado ? "Desafixar do topo" : "Fixar no topo (máx. 3)"}>
						<IconButton
							size="small"
							className={classes.botaoAcaoRapida}
							onClick={alternarFixado}
						>
							{fixado ? (
								<PinCheio fontSize="small" style={{ color: "#1E9855" }} />
							) : (
								<PinVazado fontSize="small" />
							)}
						</IconButton>
					</Tooltip>
				</span>

				<ListItemAvatar>
					<Avatar src={ticket?.contact?.profilePicUrl} />
				</ListItemAvatar>
				<ListItemText
					disableTypography
					primary={
						<span className={classes.contactNameWrapper}>
							<Typography
								noWrap
								component="span"
								variant="body2"
								color="textPrimary"
							>
								{formatarNomeOuTelefone(ticket?.contact?.name, ticket?.contact?.number)}
							</Typography>
							{}
							{ticket.status === "closed" && (
								<span className={classes.pilulaResolvido}>Resolvido</span>
							)}
							{ticket.lastMessage && (
								<Typography
									className={classes.lastMessageTime}
									component="span"
									variant="body2"
									color="textSecondary"
								>
									{isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
										<>{format(parseISO(ticket.updatedAt), "HH:mm")}</>
									) : (
										<>{format(parseISO(ticket.updatedAt), "dd/MM/yyyy")}</>
									)}
								</Typography>
							)}
						</span>
					}
					secondary={
						<span className={classes.contactNameWrapper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
							<span style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
								<Typography
									className={classes.contactLastMessage}
									noWrap
									component="span"
									variant="body2"
									color="textSecondary"
								>
									{RESUMO_DE_AUDIO.test(ticket.lastMessage || "") ? (
										<span
											style={{
												display: "inline-flex",
												alignItems: "center",
												gap: 4,
											}}
										>
											<MicIcon style={{ fontSize: 16, opacity: 0.75 }} />
											Áudio
											{duracaoDoResumo(ticket.lastMessage) &&
												` ${duracaoDoResumo(ticket.lastMessage)}`}
										</span>
									) : ticket.lastMessage ? (
										<MarkdownWrapper>{ticket.lastMessage}</MarkdownWrapper>
									) : (
										<br />
									)}
								</Typography>

								<Badge
									className={classes.newMessagesCount}
									badgeContent={ticket.unreadMessages}
									classes={{
										badge: classes.badgeStyle,
									}}
								/>
							</span>
							<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", marginTop: "8px" }}>
								<span style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
									{}
									{fixado && (
										<span style={{ color: "#1E9855", display: "flex", alignItems: "center" }} title="Fixado no topo">
											<PinCheio fontSize="small" />
										</span>
									)}
									{favorito && (
										<span style={{ color: "#ffc107", display: "flex", alignItems: "center" }} title="Meu favorito">
											<StarIcon fontSize="small" />
										</span>
									)}
										{}
										{ticket.precisaHumano && (
											<span
												className={classes.selohumano}
												title="A assistente transferiu este cliente e ninguém assumiu"
											>
												🙋 Precisa de humano
											</span>
										)}
										{}
										{ticket.user?.name && (
											<span
												className={classes.atendenteTag}
												title={`Em atendimento com ${ticket.user.name}`}
											>
												<PersonIcon style={{ fontSize: 13 }} />
												{ticket.user.name}
											</span>
										)}
									{ticket.whatsappId ? (
										<span className={classes.userTag} title={i18n.t("ticketsList.connectionTitle")}>{ticket.whatsapp?.name}</span>
									) : (
										<span
											className={classes.seloSemConexao}
											title={
												ticket.conexaoAnterior
													? `A conexão “${ticket.conexaoAnterior}”, que atendia este cliente, não está mais no sistema. Use "Trocar conexão" no menu do atendimento para continuar.`
													: 'A conexão deste atendimento não está mais no sistema. Use "Trocar conexão" no menu do atendimento para continuar.'
											}
										>
											<SignalWifiOffIcon style={{ fontSize: 10 }} />
											SEM CONEXÃO
											{ticket.conexaoAnterior ? ` · era ${ticket.conexaoAnterior}` : ""}
										</span>
									)}
									{ticket.tags?.map(tag => (
										<span key={tag.id} style={{ backgroundColor: tag.color, color: "#fff", padding: "1px 7px", borderRadius: 6, fontSize: "0.66rem", fontWeight: 600, lineHeight: "16px", whiteSpace: "nowrap" }}>
											{tag.name}
										</span>
									))}
								</span>
								{ticket.status === "pending" && (
									<span style={{ display: "flex", gap: 6 }}>
										<ButtonWithSpinner
											variant="outlined"
											size="small"
											className={classes.btnTransfer}
											loading={loading}
											onClick={e => {
												e.stopPropagation();
												setTransferTicketModalOpen(true);
											}}
										>
											Transferir
										</ButtonWithSpinner>
									</span>
								)}

								{}
								{ticket.status === "closed" && (
									<span style={{ display: "flex" }}>
										<Tooltip title="Opções">
											<IconButton
												size="small"
												onClick={abrirMenu}
												aria-label="Opções do atendimento"
											>
												<MoreVertIcon fontSize="small" />
											</IconButton>
										</Tooltip>
									</span>
								)}
							</div>
						</span>
					}
				/>
			</ListItem>
			<TransferTicketModal
				modalOpen={transferTicketModalOpen}
				onClose={() => setTransferTicketModalOpen(false)}
				ticketid={ticket.id}
				ticket={ticket}
			/>

			<Menu
				anchorEl={menuAncora}
				open={Boolean(menuAncora)}
				onClose={fecharMenu}
				getContentAnchorEl={null}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				onClick={e => e.stopPropagation()}
			>
				<MenuItem onClick={ocultarTicket}>
					<ListItemIcon style={{ minWidth: 34 }}>
						<VisibilityOffIcon fontSize="small" />
					</ListItemIcon>
					Ocultar
				</MenuItem>
				<MenuItem
					onClick={e => {
						e.stopPropagation();
						fecharMenu();
						setConfirmarApagar(true);
					}}
					style={{ color: "#d32f2f" }}
				>
					<ListItemIcon style={{ minWidth: 34, color: "#d32f2f" }}>
						<DeleteOutlineIcon fontSize="small" />
					</ListItemIcon>
					Deletar
				</MenuItem>
			</Menu>

			<ConfirmationModal
				title={`Deletar o atendimento de ${formatarNomeOuTelefone(
					ticket?.contact?.name,
					ticket?.contact?.number
				)}?`}
				open={confirmarApagar}
				onClose={setConfirmarApagar}
				onConfirm={apagarTicket}
			>
				Isso apaga a conversa inteira, sem volta. Se você só quer tirar da
				lista, use <b>Ocultar</b> — ali o histórico continua guardado.
			</ConfirmationModal>
		</React.Fragment>
	);
};

export default TicketListItem;
